<template>
  <header id="header">
    <nav class="navbar navbar-expand-md navbar-dark bg-dark">
      <a class="navbar-brand" href="#">
        <strong>ENERGY SAVING MANAGEMENT</strong>
        <small class="text-muted fs-10 ml-1">Zákaznícky portál</small>
      </a>
      <div class="d-flex">
        <notifications />
        <b-dropdown
          class="user-block"
          toggle-class="d-flex align-items-center"
          menu-class="dropdown-menu-animated"
          right
        >
          <template
            v-if="$store.getters['user/isLoggedIn']"
            slot="button-content"
          >
            <b-avatar
              :text="
                $options.filters.initials(
                  `${$root.userData.firstname} ${$root.userData.lastname}`,
                )
              "
              :src="`/storage/avatars/${$root.userData.avatar}_xs.jpg`"
              size="35px"
              variant="light"
              class="no-outline mr-2"
            />
            <span class="user-name"
              >{{ $root.userData.firstname }}
              {{ $root.userData.lastname }}</span
            >
          </template>
          <b-dropdown-item-button @click="$router.push({ name: 'profile' })">
            <b-icon class="mr-1" icon="person-fill" />
            Profil
          </b-dropdown-item-button>
          <b-dropdown-item-button @click="logout">
            <b-icon class="mr-1" icon="power" />
            Odhlásiť
          </b-dropdown-item-button>
        </b-dropdown>
      </div>
    </nav>
  </header>
</template>

<script>
import Notifications from './Notifications'

export default {
  components: {
    Notifications,
  },
  data() {
    return {}
  },
  methods: {
    logout() {
      this.$store.dispatch('user/logout', true)
    },
  },
}
</script>
